import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './coremodule/guards/auth.guard';
import { EmpleadocompraGuard } from './coremodule/guards/empleadocompra.guard';
import { ProveedorGuard } from './coremodule/guards/proveedor.guard';
import { MetaGuard } from '@ngx-meta/core';

const routes: Routes = [
  /**
   * Este módulo es el que se encarga de redireccionar al usuario
   * al módulo que pertenece.
   */
  {
    path: '',
    loadChildren: './login-selection/login-selection.module#LoginSelectionModule',
    canActivateChild: [MetaGuard],
  },
  {
    path: 'login-tipos',
    loadChildren: './login/login.module#LoginModule',
    canActivateChild: [MetaGuard],
  },
  {
    path: 'login-web',
    loadChildren: './login-web/login-web.module#LoginWebModule',
  },
  {
    path: 'certificado',
    loadChildren: './contenido-publico/contenido-publico.module#ContenidoPublicoModule',
  },
  {
    path: 'dashboard/proveedor',
    loadChildren: './proveedor/proveedor.module#ProveedorModule',
    canActivate: [AuthGuard, ProveedorGuard],
    canActivateChild: [MetaGuard],
  },
  {
    path: 'dashboard/empleado',
    loadChildren: './empleadocompra/empleadocompra.module#EmpleadocompraModule',
    canActivate: [EmpleadocompraGuard],
    canActivateChild: [MetaGuard],
  },
  {
    path: 'aspirantes',
    loadChildren: './aspirantes/aspirantes.module#AspirantesModule',
    canActivate: [AuthGuard],
    canActivateChild: [MetaGuard],
  },
  {
    path: '**',
    redirectTo: '',
    pathMatch: 'full',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      initialNavigation: 'enabled',
      scrollPositionRestoration: 'top',
      anchorScrolling: 'enabled',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule { }
